/**
 * Map raw route strings from ChatSession.page_context to human-friendly labels.
 *
 * Know route shapes:
 *   /workbench/support/dashboard  → "Support Dashboard"
 *   /workbench/my-work/:id        → "My Work"
 *   /workbench/workgroups*        → "Workgroups"
 *   /workbench/property/*         → "Property"
 *   /workbench/team/*             → "Team"
 *   /workbench/cert/*             → "Certification File"
 *
 * Fallback: title-case the last non-numeric path segment.
 * Empty / null → "Chat".
 */
export default function pageContextLabel(pageContext: string | null): string {
  if (!pageContext) {
    return 'Chat';
  }

  const path = pageContext.trim();

  if (path === '/workbench/support/dashboard') {
    return 'Support Dashboard';
  }
  if (/^\/workbench\/my-work\/\d+$/.test(path)) {
    return 'My Work';
  }
  if (/^\/workbench\/workgroups/.test(path)) {
    return 'Workgroups';
  }
  if (/^\/workbench\/property\//.test(path)) {
    return 'Property';
  }
  if (/^\/workbench\/team\//.test(path)) {
    return 'Team';
  }
  if (/^\/workbench\/cert\//.test(path)) {
    return 'Certification File';
  }

  // Fallback: last non-numeric path segment, title-cased
  const segments = path.replace(/\/$/, '').split('/');
  let last = '';
  for (let i = segments.length - 1; i >= 0; i--) {
    const seg = segments[i];
    if (seg && !/^\d+$/.test(seg)) {
      last = seg;
      break;
    }
  }
  if (last) {
    // Replace hyphens with spaces and capitalize words
    return last
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }

  return 'Chat';
}
